import React from 'react';
import Fillword from './Fillword'
import Loader from './Loader'
import { connect } from 'react-redux';
import agent from '@src/agent';
import { FILLWORD_LOADED, FILLWORD_UNLOAD } from '@src/actions';

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) =>
    dispatch({ type: FILLWORD_LOADED, payload }),
  onUnload: payload =>
    dispatch({ type: FILLWORD_UNLOAD }),
});

const mapStateToProps = state => {
  return {
    ...state.FillWord
  };
};

class fillWord extends React.Component {
  componentWillMount () {
    this.loadNext();
  }

  loadNext () {
    this.props.onUnload();
    /*
    agent.FillWords.random()
      .then(b => {
        this.props.onLoad(b)
      })
     */
    this.props.onLoad({
      fillword: [
        ['к','о','н','п','р','о','к','а','о',],
        ['ь','о','ф','и','я','т','о','л','б',],
        ['л','р','у','г','и','о','о','б','о',],
        ['а','б','р','а','ц','н','л','с','п',],
        ['т','и','у','н','н','о','о','н','и',],
        ['ш','а','р','о','т','р','ч','к','а',],
        ['ь','р','о','р','й','э','н','е','р',],
        ['н','е','в','т','е','а','н','т','г',],
        ['э','л','е','к','н','в','к','я','и',],
      ],
      words: [
        [[0,0],[0,1],[0,2],[1,2],[1,3],[2,3],[2,2],[3,2],[3,3],[3,4],[2,4],[1,4]],
        [[1,1],[2,1],[3,1],[4,1],[4,0],[3,0],[2,0],[1,0]],
        [[5,0],[5,1],[6,1]],
        [[4,2],[5,2],[6,2],[7,2],[7,1],[7,0],[6,0]],
        [[0,3],[0,4],[0,5],[1,5],[2,5],[3,5]],
        [[0,8],[1,8],[1,7],[0,7],[0,6],[1,6]],
        [[3,7],[3,8],[4,8],[4,7]],
        [[2,8],[2,7],[2,6],[3,6],[4,6],[5,6],[5,7],[5,8]],
        [[6,5],[6,6],[6,7],[6,8],[7,8],[8,8],[8,7]],
        [[8,6],[8,5],[7,5],[7,6],[7,7]],
        [[8,4],[7,4],[6,4],[5,4],[5,5],[4,5],[4,4]],
        [[8,0],[8,1],[8,2],[8,3],[7,3],[6,3],[5,3],[4,3]],
      ],
    });
  }

  render() {
    if(!this.props.FillWord) {
      return (
        <Loader/>
      )
    }

    return (
      <Fillword
        onComplete={() => {this.loadNext(); this.props.onComplete()}}
        onWord={() => this.props.onWord()}
        rows={this.props.FillWord.rows}
        words={this.props.FillWord.words}
        size={this.props.size}
        colorList={this.props.colorList}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(fillWord);